import { render } from "./StatisticsView.vue?vue&type=template&id=16c0c4b6&scoped=true&ts=true"
import script from "./StatisticsView.vue?vue&type=script&lang=ts"
export * from "./StatisticsView.vue?vue&type=script&lang=ts"

import "./StatisticsView.vue?vue&type=style&index=0&id=16c0c4b6&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c0c4b6"]])

export default __exports__